// man, handling time related stuff is such a chore...

export type TimeStampType = number;

export namespace TimeStamp {
    const REGEX_TIMESTAMP = /(?:(\d?\d):)?(\d?\d):(\d\d)(\.\d+)?/;
    export function fromString(x: string) {
        let matchres = REGEX_TIMESTAMP.exec(x);
        if (!matchres) { return undefined; }
        let h = parseInt((matchres[1]||'0'), 10);
        let m = parseInt(matchres[2]);
        let s = parseInt(matchres[3]);
        let ms = parseFloat(matchres[4]||'0');
        return h*60*60 + m*60 + s + ms;
    }
    export function toString(x: TimeStampType) {
        let ms = x - Math.floor(x);
        x = Math.floor(x);
        let s = x % 60;
        let m = (Math.floor(x / 60)) % 60;
        let h = (Math.floor(x / 60 / 60));
        return `${h}:${m>=10?'':'0'}${m}:${s>=10?'':'0'}${s}${ms.toString().substring(1)}`;
    }
}
